import Vue from 'vue';
import VueRouter from 'vue-router';

import PublicRouters from '@/router/public';
import PrivateRouters from '@/router/private';

Vue.use(VueRouter);
const routes = [];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes.concat(
    PublicRouters,
    PrivateRouters,
    {
      path: '/not_found',
      meta: {
        title: 'Page not found',
      },
      name: 'NotFound',
      component: () => import('@/modules/common/views/NotFound.vue'),
    },
    {
      path: '/tracker_information',
      meta: {
        title: 'AdBlock Information',
      },
      name: 'TrackerInfo',
      component: () => import('@/modules/common/views/TrackerInfo.vue'),
    },
    {
      path: '*',
      meta: {
        title: 'Page not found',
      },
      name: 'NotFoundPages',
      component: () => import('@/modules/common/views/NotFound.vue'),
    },
  ),
});

export default router;
